import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ticketHub from 'react/api/actions/ticketHub';
import { getResourceTo } from 'react/utils/utils';
import TicketHubFilters from './TicketHubFilters';
import TicketHubList from './TicketHubList';
import resources from './resources';

function TicketHub(props) {
  const {
    fetchTicketsAction, tickets, isLoading, isOpen
  } = props;

  useEffect(() => {
    if (isOpen) {
      fetchTicketsAction();
    }
  }, [isOpen]);

  return (
    <div className={`ticketHub ${isOpen ? 'open' : ''}`}>
      <header>
        <div className="ticketHub__title">{getResourceTo(resources.hubTitle)}</div>
        <div className="ticketHub__subtitle">{getResourceTo(resources.hubSubtitle)}</div>
      </header>
      <TicketHubFilters
        ticketHubIsOpen={isOpen}
        fetchTicketsAction={fetchTicketsAction}
      />
      <TicketHubList
        tickets={tickets}
        isLoading={isLoading}
      />
    </div>
  );
}

TicketHub.propTypes = {
  fetchTicketsAction: PropTypes.func.isRequired,
  tickets: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  tickets: state.ticketHub.get('all', []),
  isLoading: state.ticketHub.get('isLoading'),
  isOpen: state.ticketHub.get('isOpen')
});

const mapDispatchToProps = {
  fetchTicketsAction: ticketHub.actionCreators.fetchTickets
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketHub);
